import { rankItem } from "@tanstack/match-sorter-utils";

export const fuzzyFilter = (row, columnId, value, addMeta) => {
    if (!value || typeof value !== 'string' || value.trim().length < 3) {
        return true;
    }
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value.trim());

    // Store the itemRank info
    if (addMeta) {
        addMeta({
            itemRank,
        });
    }

    // Return if the item should be filtered in/out
    return itemRank.passed;
};
